module.exports = __webpack_public_path__ + "img/spirit_light_grey_ba_detail_rsh2_3.611e48c4.jpg";